{
  "exitAppPromptTitle": "¿Salir al Portal de Analytics?",
  "exitAppPromptMessage": "Está a punto de salir de FarmHQ y abrir el Portal de análisis de FarmHQ en un navegador web externo."
}
